export default "__VITE_ASSET__9ff6HRfm__"